// Class: openfl.events.StageOrientationEvent

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function openfl_events_Event() {return require("./../../openfl/events/Event");}

// Constructor

var StageOrientationEvent = function(type,bubbles,cancelable,beforeOrientation,afterOrientation) {
	if(afterOrientation == null) {
		afterOrientation = "unknown";
	}
	if(beforeOrientation == null) {
		beforeOrientation = "unknown";
	}
	if(cancelable == null) {
		cancelable = false;
	}
	if(bubbles == null) {
		bubbles = false;
	}
	(openfl_events_Event().default).call(this,type,bubbles,cancelable);
	this.beforeOrientation = beforeOrientation;
	this.afterOrientation = afterOrientation;
}

// Meta

StageOrientationEvent.__name__ = "openfl.events.StageOrientationEvent";
StageOrientationEvent.__isInterface__ = false;
StageOrientationEvent.__super__ = (openfl_events_Event().default);
StageOrientationEvent.prototype = $extend((openfl_events_Event().default).prototype, {
	clone: function() {
		var event = new StageOrientationEvent(this.type,this.bubbles,this.cancelable,this.beforeOrientation,this.afterOrientation);
		event.target = this.target;
		event.currentTarget = this.currentTarget;
		event.eventPhase = this.eventPhase;
		return event;
	},
	toString: function() {
		return this.__formatToString("StageOrientationEvent",["type","bubbles","cancelable","beforeOrientation","afterOrientation"]);
	}
});
StageOrientationEvent.prototype.__class__ = StageOrientationEvent.prototype.constructor = $hxClasses["openfl.events.StageOrientationEvent"] = StageOrientationEvent;

// Init



// Statics


StageOrientationEvent.ORIENTATION_CHANGE = "orientationChange"
StageOrientationEvent.ORIENTATION_CHANGING = "orientationChanging"

// Export

exports.default = StageOrientationEvent;